import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Tooltip } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { NavLink, useHistory } from "react-router-dom";
import { getUrlCode } from "../../utils/CustomFunc";

const Header = (props) => {
  let history = useHistory();
  const [headerSetting, setHeaderSetting] = useState(null);
  useEffect(() => {
    // if (props.settings && props.settingValues) {
    //   const titleStyle = getStyleProperties(props.settings.ld_PageTitle);

    //   const header = {
    //     company_logo: { logo: props.settings.ld_Logo_Comp.text },
    //     prod_logo: { logo: props.settings.ld_Logo_Prod.text },
    //     title: { title: props.settingValues.ld_PageTitle, style: titleStyle },
    //   };
    //   setHeaderSetting(header);
    // }
  }, [props]);

  const getImgName = (src) => {
    if (src) {
      const strArray = (src + "").split("/");
      return strArray[strArray.length - 1];
    }
  };

  return (
    <React.Fragment>
      
        <Row justify="space-around" align="middle" className="header fg-header" style={{ padding: 6 }}>
          <Col flex="140px" style={{ padding: "10px 10px", background: "#ffffff", borderRadius: 7, marginLeft: 10 }}>
            <Tooltip
              title={"FG KanBan Board"}
              placement="right"
            >
              <NavLink to={`/v02/${getUrlCode()}/dashboard`}>
                <img
                  className="spin"
                  src={"https://mnx-cdn.azurewebsites.net/content/logo/liradolf.png"}
                  width="100%"
                  style={{ maxHeight: "90px" }}
                  alt="logo"
                ></img>
              </NavLink>
            </Tooltip>
          </Col>
          <Col
            flex="auto"
            style={{ padding: "10px 10px 10px 10px", textAlign: "center" }}
          >
            <span
              style={{
                padding: "5px",
                borderRadius: "5px",
                paddingRight: "10px",
                paddingLeft: "10px"
              }}
            >
              FG KanBan Board
            </span>
          </Col>
          <Col flex="150px" style={{ padding: "10px 10px", background: "#ffffff", borderRadius: 7, marginRight: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Tooltip
              title={"FG KanBan Board"}
              placement="left"
            >
              <NavLink to={`/v02/${getUrlCode()}/dashboard`}>
                <img
                  src={"http://www.liradolf.com/wp-content/uploads/2015/01/Logo/DigitalFactory.png"}
                  width="100px"
                  style={{ maxHeight: "50px" }}
                  alt="logo"
                ></img>
              </NavLink>
            </Tooltip>
          </Col>
        </Row>
    </React.Fragment>
  );
};
export default Header;
